import React from 'react';
import { FetchResult } from '@apollo/client';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import { newViewerIntroRequestMessageUrl } from 'buyside/util/urlHelper';

import { useCreateViewerIntroRequestMutation } from 'interfaces/graphql-typings';

export enum ViewerIntroRequestButtonStatuses {
  accepted,
  hidden,
  pending,
  unsent
}

export type ViewerIntroRequestButtonProps = {
  id?: string;
  status: keyof typeof ViewerIntroRequestButtonStatuses;
  viewableId: string;
  viewableType: 'Idea';
  viewerId: string;
  viewId: string;
};

const ViewerIntroRequestButton: React.FC<ViewerIntroRequestButtonProps> = ({
  id,
  status,
  viewableId,
  viewableType,
  viewerId,
  viewId
}) => {
  const [createViewerIntroRequest, { error, loading }] = useCreateViewerIntroRequestMutation({
    update(cache, { data }) {
      cache.modify({
        id: cache.identify({ id: viewId, __typename: 'IdeaView' }),
        fields: {
          viewerIntroRequest: () => data?.createViewerIntroRequest?.viewerIntroRequest || null
        }
      });

      cache.modify({
        id: cache.identify({
          id: data?.createViewerIntroRequest?.viewerIntroRequest?.author?.id,
          __typename: 'User'
        }),
        fields: {
          sentViewerIntroRequests: existing => {
            return [...existing, data?.createViewerIntroRequest?.viewerIntroRequest];
          }
        }
      });
    }
  });

  let disabled: boolean,
    onClick,
    text: string,
    type: BUTTON_TYPES,
    url: string = '';

  switch (ViewerIntroRequestButtonStatuses[status]) {
    case ViewerIntroRequestButtonStatuses.unsent:
      disabled = false;
      onClick = (): Promise<FetchResult> =>
        createViewerIntroRequest({ variables: { viewerId, viewableId, viewableType } });
      text = 'Discuss Further';
      type = BUTTON_TYPES.PRIMARY;
      break;
    case ViewerIntroRequestButtonStatuses.pending:
      disabled = true;
      text = 'Intro Request Pending';
      type = BUTTON_TYPES.PRIMARY;
      break;
    case ViewerIntroRequestButtonStatuses.accepted:
      if (!id) return null;

      disabled = false;
      url = newViewerIntroRequestMessageUrl(id, viewerId);
      text = 'Intro Request Accepted';
      type = BUTTON_TYPES.MAJOR;
      break;
    case ViewerIntroRequestButtonStatuses.hidden:
      return null;
    default:
      return null;
  }

  return (
    <div>
      <Button
        buttonType={BUTTON_TYPES.BUTTON}
        isLoading={loading}
        disabled={disabled}
        onClick={onClick}
        size={BUTTON_SIZES.TINY}
        text={text}
        type={type}
        url={url}
      />
      {error && <p>{error.message}</p>}
    </div>
  );
};

export default ViewerIntroRequestButton;
